// extracted by mini-css-extract-plugin
module.exports = {"container":"Skills_container__3zEn2","title":"Skills_title__3LXGz","content":"Skills_content__3g9in","listContainer":"Skills_listContainer__3kJ3Q"};